
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}


function onClassDetected() {
  document.querySelector('.header__icon.header__icon--menu.header__icon--summary.link.focus-inset').setAttribute('aria-expanded', false);
  console.log(document.querySelector('.header__icon.header__icon--menu.header__icon--summary.link.focus-inset'));
}

// Créer un observer pour surveiller les mutations du DOM
var domObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var bodyClass = document.body.className;
          if (bodyClass.includes('gl-search-open')) {
              onClassDetected();
          }
      }
  });
});

// Configuration de l'observer : surveiller les changements d'attributs
var ObserverConfig = { attributes: true };

// Démarrer l'observation sur la balise <body>
domObserver.observe(document.body, ObserverConfig);


customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    if (this.mainDetailsToggle.hasAttribute('open')){
      this.mainDetailsToggle.classList.add('animate');
    } else {
      this.mainDetailsToggle.classList.remove('animate');
      
      if (document.querySelector(".mega-menu-overlay")) {
        document.querySelector(".mega-menu-overlay").remove();
      }
    }
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);